import { render, staticRenderFns } from "./table-border.vue?vue&type=template&id=5f3170bd&scoped=true"
import script from "./table-border.vue?vue&type=script&lang=js"
export * from "./table-border.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3170bd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/pre-ops-admin 管理后台-预发布环境/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5f3170bd')) {
      api.createRecord('5f3170bd', component.options)
    } else {
      api.reload('5f3170bd', component.options)
    }
    module.hot.accept("./table-border.vue?vue&type=template&id=5f3170bd&scoped=true", function () {
      api.rerender('5f3170bd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/com-public/com-yd-table/components/table-bar/components/table-border.vue"
export default component.exports